import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Detail_Ozo({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  const ScoreBlock = ({ number, isHit }) => {
    return (
      <div
        style={{
          height: 25,
          width: 30,
          border: "1px solid #0FE7F9",
          borderRadius: "5px",
          backgroundColor: isHit ? "#23C5D36B" : "#fbfbfb",
        }}
      >
        <Row className={"h-100 justify-content-center"}>
          <Col
            xs={"auto"}
            className={"align-content-center "}
            style={{
              textDecoration: "underline",
              fontSize: isHit ? "12px" : "10px",
              fontWeight: isHit ? "bold" : "normal",
            }}
          >
            {number}
          </Col>
        </Row>
      </div>
    );
  };

  const ScoreBar = ({ score }) => {
    return Array.from({ length: 10 }).map((_, index) => {
      const min = index * 10;
      const max = index * 10 + 9;
      return <ScoreBlock key={index} number={index + 1} isHit={score >= min && score <= max} />;
    });
  };

  return (
    <Row style={{ height: Number(item.height) }}>
      <div>
        {/* Sub scope name if exists */}

        <Row className={"justify-content-center"}>
          <Col xs={"auto"}>
            <div
              className={"rounded-circle flex-center "}
              style={{
                height: 40,
                width: 40,
                backgroundColor: "#0FE7F9",
                fontWeight: 700,
                fontSize: "16px",
                color: "#404040",
              }}
            >
              {elementScore}
            </div>
          </Col>
          <Col xs={"auto"} className={"ps-0 align-content-center"}>
            <div style={{ fontSize: "16px", fontWeight: "600", color: "#092441" }}>{item.name}</div>
          </Col>
        </Row>
        {/* Three column layout */}
        <Row className="align-items-center">
          {/* Left - Title */}

          <Col>
            <div
              className="_scale-detail-text-pdf-new"
              style={{ fontSize: "10px", color: "#666", lineHeight: "1.1", textAlign: "justify" }}
              dangerouslySetInnerHTML={{ __html: item.lowSideText }}
            />
          </Col>

          {/* Center - Circular progress */}
          <Col xs={"auto"} className="d-flex p-0">
            <ScoreBar score={elementScore}></ScoreBar>
          </Col>

          <Col>
            <div
              className="_scale-detail-text-pdf-new"
              style={{
                fontSize: "10px",
                color: "#666",
                lineHeight: "1.1",
                textAlign: "justify",
                textAlignLast: "right",
              }}
              dangerouslySetInnerHTML={{ __html: item.highSideText }}
            />
          </Col>
        </Row>

        {/* Bottom section - Low and High side texts */}
        <Row className="mt-3">
          <Col>
            {item.generalInformationText?.length > 2 && (
              <div
                className={"text-center"}
                style={{ fontSize: "11px", color: "#666", lineHeight: "1.4" }}
                dangerouslySetInnerHTML={{ __html: item.generalInformationText }}
              />
            )}
          </Col>
        </Row>
      </div>
    </Row>
  );
}
